<img [src]="'assets/common/icons/' + getTenancyName() + '/android-chrome-192x192.png'" onerror="this.src='assets/common/icons/android-chrome-192x192.png'" width="32">
<a href="javascript:;" (click)="onAction()" class="install-app-link ml-2">
    {{getInstallText()}}
</a>
<button class="ml-auto" mat-icon-button (click)="dismiss()"><mat-icon>close</mat-icon></button>
